<template>
  <div class="page">
    <div class="container" style="background-image: url('../assets/claimbg.jpg'); background-size: 100%; background-repeat: no-repeat;">
      <menu-home></menu-home>
      <div class="slot"></div>
      <div class="info-part">
        <div class="short-cut flex justify-center items-center w-full">
          <img
            class="login btn"
            @click="connectFox"
            title="Login"
            v-if="!walletAddress"
            src="../assets/buy/metaloginicon.png"
          >
          <img
            class="login btn"
            @click="connectRabby"
            title="Login"
            v-if="!walletAddress"
            src="../assets/buy/rabbyloginicon.png"
          >
          <img
            class="login btn"
            @click="loginHandler"
            title="Login"
            v-if="!walletAddress"
            src="../assets/buy/loginicon.png"
          >
          <img
            class="login btn"
            @click="loginOutHandler"
            v-if="walletAddress"
            title="Logout"
            src="../assets/buy/loginouticon.png"
          >
          <img
            class="login btn"
            @click="chatHandler"
            title="Help Center"
            src="../assets/buy/chaticon.png"
          >
          <img
            class="login btn"
            @click="kycHandler"
            title="kyc Center"
            src="../assets/buy/chaticon.png"
          >
        </div>
        <div class="top-address">
          <div class="item">{{!walletAddress?"Please log in with your wallet address to verify your purchase eligibility.":"Wallet Address:"}}<span>{{walletAddress}}</span></div>
          <div>{{orderData.length >0?"Order Code:":"Complete a purchase to get your Order Code"}}
            <div
              v-for="(item,index) in orderData"
              :key="index"
            >
              <div class="code-part">
                <div class="code-name">
                  {{ item.code }}
                </div>
                <div class="buy-time">{{item.createAtDesc}}</div>
                <!-- <div
                  class="go-claim"
                  @click="goDetailHandler(item)"
                >Go Detail</div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="sub-title">COUNTDOWN</div>
        <div class="buy-part">
          <div class="top-title">
            <div class="dot"></div>
            <div class="est">ENDS in <span class="time">{{ endTime }}</span></div>
          </div>
          <div class="zp-part flex just-center align-items">
            <div class="big-title">$ZP</div>
            <div
              class="zp"
              v-for="i in 10"
              :key="i"
              @click="selectZPHandler(i)"
            >
              <img
                src="../assets/zpactive.png"
                class="zpicon"
                alt=""
                v-if="i<=buyNum"
              >
              <img
                v-else
                src="../assets/zpnormal.png"
                alt=""
                class="zpicon"
              >
            </div>
          </div>
          <div class="price-part">
            <div
              class="price"
              v-if="currentShowActivityId==1"
            >${{ parseFloat( unitPrice).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 4 }) }}</div>
            <div
              class="price"
              v-else
            >${{ parseFloat( unitPrice * buyNum).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 4 }) }}</div>
            <div class="count">
              <div
                class="minus"
                :class="currentShowActivityId==1?['disabled']:[]"
                @click="minusHandler"
              >-</div>
              <div class="num">{{ buyNum }}</div>
              <div
                class="plus"
                :class="currentShowActivityId==1?['disabled']:[]"
                @click="addHandler"
              >+</div>
            </div>
          </div>
          <div
            class="buy-btn"
            :class="(token=='' || walletAddress=='' || isCanBuy==0)?['buy-btn-disabled']:[]"
            @click="buyHandler"
          >BUY</div>
          <div class="tips">{{isCanBuy==0?reason:""}}

          </div>
        </div>
        <div class="desc">
          <div>PROJECT INFO</div>
          <div class="desc-sub">Web3.0 Plants vs Zombies reinvents the classic merge-to-upgrade zombie survival genre with blockchain-powered rewards and AI-driven gameplay. In Zombie-to-Earn mode, players defend their garden, assemble zombie mining teams, and earn BIG!
            $ZP (Zombie Power) is the official game token for Web3PvZ, designed to seamlessly integrate blockchain technology with immersive gameplay. As the lifeblood of the Web3PvZ economy, $ZP facilitates a dynamic Zombie-to-Earn system, giving players ownership and tangible value within the game.</div>
          <div class="flex space-between align-items t-part">
            <img
              src="../assets/buy/t1.png"
              alt=""
            >
            <img
              src="../assets/buy/t2.png"
              alt=""
            >
            <img
              src="../assets/buy/t3.png"
              alt=""
            >
            <img
              src="../assets/buy/t4.png"
              alt=""
            >
          </div>
          <div>
            <table class="table-box">
              <tr>
                <td>Round</td>
                <td>% of Total Supply</td>
                <td># of token</td>
                <td>Price</td>
                <td>Raising</td>
                <td>FDV</td>
              </tr>
              <tr>
                <td>VIP</td>
                <td>{{ totalSupplyTableCellDesc }}</td>
                <td>{{ ofTokenTableCellDesc }}</td>
                <td>{{ tokenPriceInfoDesc }}</td>
                <td>{{ raisingTableCellDesc }}</td>
                <td>{{ fdvTableCellDesc }}</td>
              </tr>
              <tr>
                <td>Public</td>
                <td>{{ viptotalSupplyTableCellDesc }}</td>
                <td>{{ vipofTokenTableCellDesc }}</td>
                <td>{{ viptokenPriceInfoDesc }}</td>
                <td>{{ vipraisingTableCellDesc }}</td>
                <td>{{ vipfdvTableCellDesc }}</td>
              </tr>
            </table>
          </div>
          <!-- token info -->
          <div class="token-info">
            <div class="title">
              <div
                class="token-info-title"
                :class="tag==1?['tag-active']:[]"
                @click="showTag(1)"
              >Token Info for VIP Round</div>
              <div
                class="token-info-title"
                :class="tag==2?['tag-active']:[]"
                @click="showTag(2)"
                v-if="0"
              >Token Info for Public Round</div>
            </div>

            <div class="token-info-content">
              <div class="token-info-content-title">
                <div>Total Raise</div>
                <div>{{ totalRaiseInfoDesc }}</div>
              </div>
              <div class="token-info-content-title">
                <div>Token Price</div>
                <div>{{ tokenPriceInfoDescNew }}</div>
              </div>
              <div class="token-info-content-title">
                <div>Token Sysbol</div>
                <div>{{ tokenSymbolInfoDesc }}</div>
              </div>
              <div class="token-info-content-title">
                <div>Network</div>
                <div>{{ networkInfoDesc }}</div>
              </div>
              <div class="token-info-content-title">
                <div>Total Supply</div>
                <div>{{ totalSupply }}</div>
              </div>
              <div
                class="token-info-content-title"
                v-if="false"
              >
                <div>Initial Circulating Supply (excluding Liquidity Management)</div>
                <div>{{ initialCirculatingSupplyInfoDesc }}</div>
              </div>
              <div
                class="token-info-content-title"
                v-if="false"
              >
                <div>Initial Market Cap (excluding Liquidity Management)</div>
                <div>{{ initialMarketCapInfoDesc }}</div>
              </div>
              <div class="token-info-content-title">
                <div>Token Listing</div>
                <div>{{ tokenListingInfoDesc }}</div>
              </div>
              <div
                class="token-info-content-title"
                style="border:none"
              >
                <div>Vesting Details</div>
                <div>{{ vestingDetailsInfoDesc }}</div>
              </div>
            </div>
          </div>
          <!-- special events -->
          <div class="special">
            <div class="title">SPECIAL EVENTS</div>
            <div class="info">
              <img
                class="info-icon"
                src="../assets/buy/todolisticon.png"
                alt=""
              >
              <div class="subtitle">WHITELIST DISCOUNT</div>
              <div class="subcontent">Reserved for recognized KOLs, community builders, and major contributors driving the project's
                growth.</div>
              <div class="short-content">Apply Now: <a
                  class="doc"
                  href="https://t.me/Vincy928"
                  target="_blank"
                >https://t.me/Vincy928</a></div>
            </div>
          </div>
          <div class="bottom-part">
            <div class="title">Risk Disclaimer and Important Notices</div>
            <div class="bottom-content">
              <div class="content-conver">
                <div>1.MARKET RISK</div>
                <div class="content border-right">The price of ZP tokens is subject to market
                  fluctuations and
                  supply-demand dynamics. Invest with
                  caution and conduct
                  thorough due diligence.</div>
              </div>
              <div class="content-conver">
                <div>2.TOKEN UNLOCK</div>
                <div class="content border-right">ZP tokens acquired through the subscription will be released according to a predetermined
                  vesting schedule. Early
                  unlocking is not
                  supported.</div>
              </div>
              <div class="content-conver">
                <div>3.LEGAL COMPLIANCE</div>
                <div class="content">This public offering
                  adheres to all relevant legal and regulatory
                  requirements. However, certain jurisdictions may have restrictions. Users are responsible for assessing the legality of their
                  participation.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <QRCodeView
      v-if="showQrcodeTag"
      @hideQrCode="hideQrCode"
      :url="qrcodeUrl"
    ></QRCodeView>
  </div>
</template>
<script>
import MenuHome from './MenuHome.vue';
import QRCode from 'qrcode';
import { OKXUniversalProvider } from "@okxconnect/universal-provider";
import QRCodeView from './QRCodeView.vue';
import { pvzwebAirdropBuy, pvzwebAirdropInfo, pvzwebLoginByWallet, pvzwebUserOrderList } from '@/common/method';
import { emitter, Events } from '@/common/mitt';
import lib from '@/common/rabby';
import { refreshWalletAddress, launch } from '../common/KycManager';
export default {
  components: { MenuHome, QRCodeView },
  data () {
    return {
      zkMeWidget: null,
      showQrcodeTag: false,
      token: "",
      reason: "",
      tips1: "You are not currently whitelisted for the public sale.",
      tips2: "You have already reached the maximum purchase limit.",
      tips3: "Please log in to proceed with your purchase.",
      tips4: "Public sale sold out.",
      orderData: [],
      tag: 1,
      endTime: "",
      unitPrice: 0,
      activeId: 9,
      buyNum: 10,
      walletAddress: "",
      qrcodeUrl: '',
      okxUniversalProvider: null,
      seedTotal: '0.71%',
      kolTotal: '0.71%',
      publicTotal: '0.71%',

      seedToken: 100,
      kolToken: 100,
      priceToken: 100,

      seedPrice: 100,
      kolPrice: 100,
      publicPrice: 100,

      seedRaising: 100,
      kolRaising: 100,
      publicRaising: 100,

      seedFDV: 100,
      kolFDV: 100,
      publicFDV: 100,


      totalRaise: '',
      tokenPriceInfoDesc: '',
      tokenSymbolInfoDesc: '',
      network: '',
      totalSupply: '',
      initialCirculatingSupplyInfoDesc: '',
      initialMarketCapInfoDesc: '',
      networkInfoDesc: '',
      ofTokenTableCellDesc: '',
      tokenListingInfoDesc: '',
      vestingDetailsInfoDesc: '',
      totalRaiseInfoDesc: '',
      vipofTokenTableCellDesc: "",
      vipraisingTableCellDesc: "",
      vipofdvTableCellDesc: "",
      viptotalSupplyTableCellDesc: "",
      viptokenPriceInfoDesc: "",
      countDown: 0,
      countDownIndex: 0,

      isCanBuy: 0, // 是否可购买

      currentShowActivityId: 0,

      allInfo: {},
    }
  },
  mounted () {
    this.getInfo();
    this.initKYC();
    emitter.on(Events.Update_Account, this.updateAccountHandler);

    let url = window.location.search;
    if (url.indexOf("?") != -1) {
      let str = url.substr(1);
      let strs = str.split("&");
      for (let i = 0; i < strs.length; i++) {
        if (strs[i].split("=")[0] == "address") {
          this.walletAddress = strs[i].split("=")[1];
          this.loginByWallet(this.walletAddress);
          break;
        }
      }
    }

  },
  unmounted () {
    emitter.off(Events.Update_Account, this.updateAccountHandler);
    lib.reset();
  },
  methods: {
    kycHandler () {
      launch()
    },
    initKYC () {
      refreshWalletAddress(this.walletAddress);
    },
    updateAccountHandler (accounts) {
      this.loginByWallet(accounts)
    },
    connectRabby () {
      if (window.ethereum && window.ethereum.isRabby == true) {
        lib.connectWithEIP6963()
      } else {
        emitter.emit(
          Events.EventMin,
          `Please install ${'Rabby Wallet'} to log in or select an alternative wallet.`
        );
      }
    },
    connectFox () {
      console.log(window.ethereum, window.ethereum.isMetaMask)
      if (window.ethereum && window.ethereum.isMetaMask == true) {
        lib.connectWithEIP6963("MetaMask")
      } else {
        emitter.emit(
          Events.EventMin,
          `Please install ${'MetaMask'} to log in or select an alternative wallet.`
        );
      }
    },
    minusHandler () {
      if (this.currentShowActivityId == 1) return;
      this.buyNum -= 1;
      this.buyNum < 1 ? this.buyNum = 1 : null;
    },
    addHandler () {
      if (this.currentShowActivityId == 1) return;
      this.buyNum += 1;
      this.buyNum > 10 ? this.buyNum = 10 : null;
    },
    async loginOutHandler () {
      localStorage.setItem("token", "");

      lib.disconnect();

      if (window.okxwallet)
        await window.okxwallet.disconnect();
      if (this.okxUniversalProvider)
        await this.okxUniversalProvider.disconnect();

      this.clearData();
    },
    selectZPHandler (index) {
      if (this.currentShowActivityId == 1) return;
      this.buyNum = index;
    },
    clearData () {
      this.token = "";
      this.tag = 1;
      this.walletAddress = "";
      this.qrcodeUrl = '';
      this.okxUniversalProvider = null;
      this.orderData = [];
      this.okxUniversalProvider = null;
      this.walletAddress = "";
      this.list = [];
      this.showQrcodeTag = false;
    },
    formatTimeByString (time) {
      if (typeof time !== 'number' || time < 0) {
        return time
      }
      var day = parseInt(time / (3600 * 24))
      time = time % (3600 * 24)
      var hour = parseInt(time / 3600)
      time = time % 3600
      var minute = parseInt(time / 60)
      time = time % 60
      var second = parseInt(time)
      return (day[1] ? day : '0' + day) + ' Day ' +
        ([hour, minute, second]).map(function (n) {
          n = n.toString()
          return n[1] ? n : '0' + n
        }).join(':') +
        " s "
    },
    chatHandler () {
      window.open("https://t.me/Telgatherminigames")
    },
    hideQrCode () {
      this.showQrcodeTag = false;
      this.okxUniversalProvider = null;
    },
    showTag (index) {
      this.tag = index;
      let current = this.allInfo.airdropList[0];
      if (index == 1) {
        current = this.allInfo.airdropList[0]; //kol
      } else {
        current = this.allInfo.airdropList[1];
      }

      this.totalSupply = current.totalSupplyInfoDesc
      this.tokenSymbolInfoDesc = current.tokenSymbolInfoDesc
      this.totalRaiseInfoDesc = current.totalRaiseInfoDesc
      this.tokenPriceInfoDescNew = current.tokenPriceInfoDesc
      this.initialCirculatingSupplyInfoDesc = current.initialCirculatingSupplyInfoDesc
      this.initialMarketCapInfoDesc = current.initialMarketCapinfoDesc
      this.vestingDetailsInfoDesc = current.vestingDetailsInfoDesc
      this.tokenListingInfoDesc = current.tokenListingInfoDesc
      this.networkInfoDesc = current.networkInfoDesc
    },

    startCountingDown () {
      this.countDownIndex = setInterval(() => {
        this.countSeconds();
      }, 1000);
    },

    countSeconds () {
      this.endTime = this.formatTimeByString(this.countDown / 1000)
      this.countDown -= 1000
      if (this.countDown < 0) {
        clearInterval(this.countDownIndex);
        this.endTime = this.formatTimeByString(0)
      }
    },
    async getInfo () {
      let result1 = await pvzwebAirdropInfo({ token: this.token })
      let ax_result = result1.data;
      let result = ax_result.data;
      console.log(result)
      this.allInfo = result;
      this.currentShowActivityId = result.activeId; // 当前激活的
      let current = result.airdropList[0]
      for (var itemm in result.airdropList) {
        if (result.airdropList[itemm].id == result.activeId) {
          current = result.airdropList[itemm];
          break;
        }
      }
      this.isCanBuy = result.isCanBuy;
      this.reason = result.reason;
      let vip = result.airdropList[1];
      this.endTime = current.endAtDesc;
      this.activeId = current.id;
      this.unitPrice = current.unitPrice;
      console.log(result, result.airdropList)
      this.showTag(1);

      this.countDown = current.countDown;

      this.tokenPriceInfoDesc = current.tokenPriceInfoDesc

      this.kolTotal = current.kolTotal;

      this.ofTokenTableCellDesc = current.ofTokenTableCellDesc;
      this.fdvTableCellDesc = current.fdvTableCellDesc;
      this.raisingTableCellDesc = current.raisingTableCellDesc;
      this.totalSupplyTableCellDesc = current.totalSupplyTableCellDesc;
      this.tokenPriceInfoDesc = current.tokenPriceInfoDesc;

      this.vipofTokenTableCellDesc = vip.ofTokenTableCellDesc;
      this.vipfdvTableCellDesc = vip.fdvTableCellDesc;
      this.vipraisingTableCellDesc = vip.raisingTableCellDesc;
      this.viptotalSupplyTableCellDesc = vip.totalSupplyTableCellDesc;
      this.viptokenPriceInfoDesc = vip.tokenPriceInfoDesc;
      this.countSeconds();

      this.startCountingDown();
    },
    buyHandler () {
      if (this.token == "") {
        this.loginHandler();
      } else {
        pvzwebAirdropBuy({ token: this.token, id: this.activeId, amount: this.buyNum }).then(res => {
          let ax_result = res.data;
          let result = ax_result.data;
          window.open(result);
        })
      }
    },
    loginByWallet (address) {
      this.walletAddress = address;
      refreshWalletAddress(this.walletAddress);
      if (this.walletAddress) {
        pvzwebLoginByWallet({ walletType: 'okx', walletAddress: this.walletAddress }).then(res => {
          let ax_result = res.data;
          if (ax_result.errCode != 0) {
            // alert(ax_result.errMsg);
            emitter.emit(Events.EventMin, ax_result.errMsg);
            this.reason = ax_result.errMsg;
            return;
          }
          let result = ax_result.data;
          this.token = result.token;
          localStorage.setItem("token", this.token)
          this.showQRCodeTag = false;
          this.getInfo();
          this.getOrderList();
        })
      }
      return;
    },
    async getOrderList () {
      pvzwebUserOrderList({ token: localStorage.getItem("token") }).then(res => {
        let result = res.data;
        if (result.errCode == 0) {
          let data = result.data;
          this.orderData = [];
          for (var item of data) {
            if (item.orderStatus == 1) {
              this.orderData.push(item);
            }
          }
        }
      })
    },
    async loginHandler () {
      if (typeof window.okxwallet !== 'undefined') {
        console.log('OKX is installed!')
        try {
          const accounts = await window.okxwallet.request({ method: 'eth_requestAccounts' })
          console.log(accounts)
          this.loginByWallet(accounts[0])
        } catch (error) {
          // alert("cancel")
          console.log('OKX is cancel!')
        }
        // window.okxwallet.on('accountsChanged', (accounts) => { console.log(accounts); this.loginByWallet(accounts[0]) });
      }
      else {
        this.init();
      }
    },
    async init () {
      this.okxUniversalProvider = await OKXUniversalProvider.init({
        dappMetaData: {
          name: "Web3.0 Plants vs Zombies",
          icon: "https://res.telgather.com/mini/ton/Telgather/Telgather.jpg"
        },
      })


      // 生成 universalLink
      this.okxUniversalProvider.on("display_uri", (uri) => {
        console.log("display_uri:", uri);
        this.showQRCode(uri);
      });
      // session 信息变更（例如添加自定义链）会触发该事件；
      this.okxUniversalProvider.on("session_update", (session) => {
        console.log(JSON.stringify(session));
        let result = (session);
        let wallet = result.namespaces.eip155.accounts[0];
        let address = wallet.split(':')
        this.loginByWallet(address[address.length - 1])
      });
      // 断开连接会触发该事件；
      this.okxUniversalProvider.on("session_delete", ({ topic }) => {
        console.log(topic);
      });

      let session = await this.okxUniversalProvider.connect({
        namespaces: {
          eip155: {
            // 请按需组合需要的链id传入，多条链就传入多个
            chains: ["eip155:1", "eip155:137"],
            defaultChain: "1",
            rpcMap: {
              "137": "https://polygon.drpc.org"
            }
          }
        },
        optionalNamespaces: {
          eip155: {
            chains: ["eip155:43114"]
          }
        },
        sessionConfig: {
          redirect: ""
        }
      })
      this.hideQrCode();

      console.log("session", session)

      let result = (session);
      let wallet = result.namespaces.eip155.accounts[0];
      let address = wallet.split(':')
      this.loginByWallet(address[address.length - 1])

    },
    showQRCode (link) {
      // 展示二维码
      // let node = this.qrcodeNode;
      // var qrcode = new QRCode(-1, QRErrorCorrectLevel.L);
      // qrcode.addData(link);
      // qrcode.make();
      this.showQrcodeTag = true;

      const text = link;  // 要编码的内容
      // const imageElement = document.getElementById('qrcodeImage');  // 获取 img 元素
      let that = this;
      QRCode.toDataURL(text, function (error, url) {
        if (error) {
          console.error(error);
        } else {
          that.qrcodeUrl = url;
          // imageElement.src = url;  // 将二维码图像显示在 img 元素中
          console.log("QR Code image successfully generated!");
        }
      });


    },
  }
}
</script>
<style lang="scss" scoped>
@import './token.scss';
</style>